import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import PolicyCustomTable from "./PolicyCustomTable";

const PoliciesModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.open? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				Policies
			</DialogTitle>
			<DialogContent>
				<PolicyCustomTable/>
			</DialogContent>
		</Dialog>
	);

}

export default PoliciesModal;